<template>
  <v-btn
    text
    color="red"
    @click="$router.push('/profile/money-request')"
    v-if="waitingMoneyRequest.length>0"
  >{{waitingMoneyRequest.length}} Demande de fonds en attente</v-btn>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data: () => ({}),
  mounted() {
    this.initialize();
  },
  computed: {
    ...mapGetters("moneyRequest", ["moneyRequests"]),
    waitingMoneyRequest() {
      return this.moneyRequests.filter(request => request.status == "asked");
    }
  },
  methods: {
    initialize() {
      this.list();
    },
    ...mapActions("moneyRequest", ["list"])
  }
};
</script>

<style>
</style>